import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { show } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'anonymousSharerMessage',
    'personalisedSharerMessage',
    'sharerName',
  ];

  connect() {
    if (!CurrentPage.isArticlePaywalled()) return false;
    if (!CurrentPage.isAccessWallIframeUnlocked()) return false;
    if (!CurrentUser.isGuest()) return false;

    const shareUrl = CurrentPage.getShareUrl();
    if (shareUrl.sharedBy) {
      this.sharerNameTarget.innerHTML = shareUrl.sharedBy;
      show(this.personalisedSharerMessageTarget);
    } else {
      show(this.anonymousSharerMessageTarget);
    }

    show(this.element);
  }
}

